export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128')
];

export const server_loads = [];

export const dictionary = {
		"/": [27],
		"/(app)/(login)/auth": [107,[2,25]],
		"/(app)/(other)/change-organization": [116,[2]],
		"/(app)/(login)/cred-login": [108,[2,25]],
		"/(app)/(authorised)/(provider)/credentialing-agent": [37,[2,8]],
		"/(app)/(authorised)/(provider)/credentialing-agent/[sessionId]": [38,[2,8]],
		"/(app)/(authorised)/(provider)/cvo-requests": [39,[2,8,10]],
		"/(app)/(authorised)/(provider)/cvo-requests/[path]": [40,[2,8,10]],
		"/(app)/(authorised)/(provider)/discover/license-verification": [41,[2,8]],
		"/(app)/(authorised)/(provider)/discover/provider-profile": [42,[2,8]],
		"/(app)/(authorised)/(provider)/discover/provider-profile/[id]": [43,[2,8]],
		"/(app)/(authorised)/(provider)/discover/search": [44,[2,8]],
		"/(app)/(authorised)/(embed)/embed/access-denied": [28,[2,3]],
		"/(app)/(authorised)/(embed)/embed/credentialing-agent/access-denied": [29,[2,3]],
		"/(app)/(authorised)/(embed)/embed/credentialing-agent/launcher": [30,[2,3]],
		"/(app)/(authorised)/(embed)/embed/credentialing-agent/session": [31,[2,3]],
		"/(app)/(login)/embed/init": [109,[2,25]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests": [34,[2,4,7]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests/[path]": [35,[2,4,7]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)": [32,[2,4,5,6]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)/[path]/[...rest]": [33,[2,4,5,6]],
		"/(app)/(login)/forgot-password": [110,[2,25]],
		"/(app)/(authorised)/(provider)/groups": [49,[2,8]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]": [45,[2,8]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview": [46,[2,8,11,12]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview/[tab]": [47,[2,8,11,12]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/payer/[id]": [48,[2,8,11]],
		"/(app)/(login)/login": [111,[2,26]],
		"/(app)/(login)/login/callback": [112,[2,26]],
		"/(other)/maintenance": [124],
		"/(app)/(authorised)/(provider)/my-network": [50,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests": [51,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/assigned": [52,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/cancellation-request": [53,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues": [60,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications": [61,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications/[tab=failedVerificationTab]": [62,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues/monitoring-alerts": [63,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues/npdb": [64,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/issues/sanctions": [65,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/monitoring": [66,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/dashboard": [67,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/providers": [68,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review": [69,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/board": [70,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh": [54,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/import": [55,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/merge": [56,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/certificate": [71,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/cvo": [57,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/dea": [72,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/license": [73,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/medicaid": [74,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npdb": [75,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npi": [76,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile": [77,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile/[tab=profileImportListTab]": [78,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/sanctions": [79,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needsReview/[...any]": [58,[2,8,13,14]],
		"/(app)/(authorised)/(provider)/my-network/provider-license": [80,[2,8,13]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/providerLicense/[...any]": [59,[2,8,13,15]],
		"/(app)/(authorised)/(provider)/my-network/providers": [81,[2,8,13]],
		"/(app)/(login)/new-password": [113,[2,25]],
		"/(other)/not-support": [125],
		"/(app)/(other)/org-picker": [117,[2]],
		"/(app)/(other)/print/[providerId=uuid]/[entity]/[id]": [119,[2]],
		"/(app)/(other)/print/[entityType]/[entityId=uuid]/[entity]/[id]": [118,[2]],
		"/(app)/(authorised)/(provider)/(backward-routes)/provider-detail/[...any]": [36,[2,8,9]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]": [82,[2,8,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge": [84,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]": [85,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/add": [86,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/review": [87,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge": [88,[2,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]": [89,[2,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/add": [90,[2,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/resolve": [91,[2,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/review": [92,[2,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment": [93,[2,8,16,19]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment/[tab]": [94,[2,8,16,19]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/[...tab]": [83,[2,8,16]],
		"/(other)/report-template": [126],
		"/(other)/report-template/[template]": [127],
		"/(app)/(login)/reset-password": [114,[2,25]],
		"/(app)/(other)/review/alert/[id]": [122,[2]],
		"/(app)/(other)/review/[providerId=uuid]/[entity]/[id]": [121,[2]],
		"/(app)/(other)/review/[entityType]/[entityId=uuid]/[entity]/[id]": [120,[2]],
		"/(app)/(other)/select-providers/[entityId]": [123,[2]],
		"/(app)/(authorised)/settings": [95,[2,20]],
		"/(app)/(authorised)/settings/account": [96,[2,20,21]],
		"/(app)/(authorised)/settings/account/[tab]": [97,[2,20,21]],
		"/(app)/(authorised)/settings/audit-logs": [98,[2,20]],
		"/(app)/(authorised)/settings/authentication": [99,[2,20,22]],
		"/(app)/(authorised)/settings/authentication/[tab]": [100,[2,20,22]],
		"/(app)/(authorised)/settings/coverage": [101,[2,20,23]],
		"/(app)/(authorised)/settings/coverage/[tab]": [102,[2,20,23]],
		"/(app)/(authorised)/settings/cred-agent": [103,[2,20,24]],
		"/(app)/(authorised)/settings/cred-agent/[tab]": [104,[2,20,24]],
		"/(app)/(authorised)/settings/feature-preference": [105,[2,20]],
		"/(app)/(authorised)/settings/sources": [106,[2,20]],
		"/sso/admin": [128],
		"/(app)/(login)/temp-token-login": [115,[2,25]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';